/**
 * Thin compatibility shim — old links and FCM push notifications still
 * point to ``/bookings`` (e.g. the post-booking success modal "My
 * Bookings" CTA). Redirect to the new unified ``/orders?tab=bookings``
 * view.
 */
import { Navigate } from "react-router-dom";

export default function CustomerBookings() {
    return <Navigate to="/orders?tab=bookings" replace />;
}
